export class feedBackModel {
  "name": string = "";
  "phoneNo": number;
  "feedback": string = "";
  "consumerNo": string = "";
  "emailId": string = "";
  "userType": string = "";
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/feedback/feedback.model.ts